var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WireframeNested',{attrs:{"title":"Опыт компаний"}},[_c('LayoutOneColumn',{staticClass:"pa-2"},[_c('p',[_vm._v(" TODO: про продвинутое использование веб технологий и про опыт их применения компаниями ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }